/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import notFoundImg from "../../assets/404.svg";
import { notFoundErrorContainer } from "./styles";
import { useIsMobile } from "../../hooks/useIsMobile";
import { CustomButton } from "../../atoms/CustomButton";
import {
  CustomButtonColor,
  CustomButtonTypes,
} from "../../atoms/CustomButton/interface";
import { useHistory } from "react-router-dom";

export const NotFound: React.FC<any> = () => {
  const isMobile = useIsMobile();
  const history = useHistory();
  const redirectHome = () => {
    history.push("/");
  };
  return (
    <div css={notFoundErrorContainer(isMobile ? true : false)}>
      <img src={notFoundImg} alt="error" className="error-rangoon" />
      <div className="error-text">
        <div className="four-o-four">404</div>
        <div className="not-found">Page not found</div>
        <div className="text">
          Looks like you took a wrong turn. Let's get you back on track
        </div>
        <CustomButton
          color={CustomButtonColor.PRIMARY}
          type={CustomButtonTypes.BUTTON}
          className="home-button"
          onClick={redirectHome}
        >
          Go To Partner.fit
        </CustomButton>
      </div>
    </div>
  );
};
